import React from 'react';
import Head from 'next/head';

interface HtmlTitleProps {
	label: string;
}

/**
 * This component provides html title page injection mechanism.
 * @param label
 */
export const HtmlTitle: React.FC<HtmlTitleProps> = ({
	label
}: HtmlTitleProps) => {
	return (
		<Head>
			<title key='title'>{label}</title>
		</Head>
	);
};
